import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Typography } from '@mui/material';

const CustomLoader = ({
    size = 16,
    message = 'Loading...',
    direction = 'column',
    gap = 1,
    sx = {},
    spinnerSx = {},
    messageSx = {},
    showMessage = true,
    fullHeight = false,
    minHeight,
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: direction,
                justifyContent: 'center',
                alignItems: 'center',
                gap,
                py: 2,
                ...(fullHeight && { height: '100%', minHeight: minHeight || '200px' }),
                ...sx,
            }}
        >
            <CircularProgress size={size} sx={spinnerSx} />
            {showMessage && message && (
                <Typography variant="body2" sx={messageSx}>
                    {message}
                </Typography>
            )}
        </Box>
    );
};

CustomLoader.propTypes = {
    size: PropTypes.number,
    message: PropTypes.string,
    direction: PropTypes.oneOf(['row', 'column', 'row-reverse', 'column-reverse']),
    gap: PropTypes.number,
    sx: PropTypes.object,
    spinnerSx: PropTypes.object,
    messageSx: PropTypes.object,
    showMessage: PropTypes.bool,
    fullHeight: PropTypes.bool,
    minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

CustomLoader.defaultProps = {
    size: 16,
    message: 'Loading...',
    direction: 'column',
    gap: 1,
    sx: {},
    spinnerSx: {},
    messageSx: {},
    showMessage: true,
    fullHeight: false,
    minHeight: undefined,
};

export default CustomLoader;
